"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estiloJornada = exports.tipoDeJornada = exports.ValidadorDePedidoDeHorasExtras = exports.Jornada = void 0;
const excecoes_1 = require("./excecoes");
/**
 * Representa uma classe para manipulação de horas.
 */
class ConversorDeHoras {
    constructor(horas) {
        this.regexValidadorDeHoras = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        this.data = this.formatarEntrada(horas);
    }
    formatarEntrada(horas) {
        if (!this.regexValidadorDeHoras.test(horas)) {
            throw new excecoes_1.FormatoDeHorasInvalido();
        }
        // A data de referência é 1100-01-01, pois o horário é o que importa
        return new Date(`1100-01-01T${horas}:00`);
    }
}
/**
 * @description Classe que representa uma jornada de trabalho
 * @class Jornada
 */
class Jornada {
    constructor(inicio, fim) {
        this.regexValidadorDeHoras = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        this.inicio = this.formatarEntrada(inicio);
        this.fim = this.formatarEntrada(fim);
    }
    formatarEntrada(entrada) {
        if (typeof entrada === 'string') {
            const entradaHoras = new ConversorDeHoras(entrada);
            return entradaHoras.data;
        }
        else if (entrada instanceof Date) {
            return entrada;
        }
        else {
            throw new excecoes_1.EntradaDeDadosInvalida();
        }
    }
    alterarJornada(inicio, fim) {
        this.inicio = this.formatarEntrada(inicio);
        this.fim = this.formatarEntrada(fim);
    }
    jornadaAtravessaDia() {
        if (this.inicio.getDate() === this.fim.getDate()) {
            return this.fim.getTime() < this.inicio.getTime();
        }
        else {
            return this.inicio.getDate() !== this.fim.getDate();
        }
    }
    getJornada() {
        return [this.inicio, this.fim];
    }
    static adicionarUmDiaNaData(data) {
        const novaData = new Date(data);
        novaData.setDate(novaData.getDate() + 1);
        return novaData;
    }
    static concatenarDataEmHorario(data, horario) {
        const ano = data.getFullYear();
        const mes = (data.getMonth() + 1).toString().padStart(2, '0');
        const dia = data.getDate().toString().padStart(2, '0');
        const hora = horario.getHours().toString().padStart(2, '0');
        const minuto = horario.getMinutes().toString().padStart(2, '0');
        const segundos = '00';
        const dataCombinada = new Date(`${ano}-${mes}-${dia}T${hora}:${minuto}:${segundos}`);
        return dataCombinada;
    }
}
exports.Jornada = Jornada;
/**
 * @description Classe que valida e formata um pedido de horas extras
 * @class ValidadorDePedidoDeHorasExtras
 */
class ValidadorDePedidoDeHorasExtras {
    constructor(dataDoPedido, jornadaDoDia, jornadaDeHorasExtras) {
        this.dataDoPedido = dataDoPedido;
        this.jornadaDoDia = jornadaDoDia;
        this.jornadaDeHorasExtras = jornadaDeHorasExtras;
    }
    /**
     * Formatar o pedido de horas extras
     * @returns Date[] - [inicio, fim] do pedido de horas extras
     */
    pegarPedidoFormatado() {
        let resultadoPedidoHorasExtras;
        /**
         * Caso a jornada do dia não atravesse o dia:
         * - o pedido de HE começa no mesmo dia.
         *
         * Caso a jornada atravesse o dia:
         * - e caso o pedido comece após o meio dia:
         *     pedido de HE começa no dia da jornada
         * - e Caso o pedido começe antes do meio dia:
         *     pedido de HE começa no dia seguinte
         */
        if (!this.jornadaDoDiaAtravessaDia()) {
            resultadoPedidoHorasExtras = this.jornadaDeHorasExtras.getJornada();
        }
        else {
            if (this.inicioPedidoEhAposMeioDia()) {
                const inicioJornada = Jornada.concatenarDataEmHorario(this.dataDoPedido, this.jornadaDeHorasExtras.inicio);
                const fimJornada = Jornada.concatenarDataEmHorario(this.dataDoPedido, this.jornadaDeHorasExtras.fim);
                resultadoPedidoHorasExtras = [inicioJornada, fimJornada];
            }
            else {
                const inicioJornada = Jornada.concatenarDataEmHorario(Jornada.adicionarUmDiaNaData(this.dataDoPedido), this.jornadaDeHorasExtras.inicio);
                const fimJornada = Jornada.concatenarDataEmHorario(Jornada.adicionarUmDiaNaData(this.dataDoPedido), this.jornadaDeHorasExtras.fim);
                resultadoPedidoHorasExtras = [inicioJornada, fimJornada];
            }
        }
        /**
         * Caso o horário fim pedido pelo usuário
         * seja menor que o horário início pedido:
         * - o pedido de horas extras atravessa o dia,
         * portanto adicionamos + um dia ao horário fim do pedido
         */
        if (this.jornadaDeHorasExtras.jornadaAtravessaDia()) {
            const fimJornadaDoDia = Jornada.adicionarUmDiaNaData(resultadoPedidoHorasExtras[1]);
            resultadoPedidoHorasExtras[1] = fimJornadaDoDia;
        }
        return resultadoPedidoHorasExtras;
    }
    atualizarJornadaDeHorasExtras(inicio, fim) {
        let inicioFormatado, fimFormatado;
        if (typeof inicio === 'string' && typeof fim === 'string') {
            inicioFormatado = new ConversorDeHoras(inicio).data;
            fimFormatado = new ConversorDeHoras(fim).data;
            inicioFormatado = Jornada.concatenarDataEmHorario(this.dataDoPedido, inicioFormatado);
            fimFormatado = Jornada.concatenarDataEmHorario(this.dataDoPedido, fimFormatado);
        }
        else if (inicio instanceof Date && fim instanceof Date) {
            inicioFormatado = inicio;
            fimFormatado = fim;
        }
        else {
            throw new excecoes_1.EntradaDeDadosInvalida();
        }
        this.jornadaDeHorasExtras.alterarJornada(inicioFormatado, fimFormatado);
        return this;
    }
    atualizarJornadaDoDia(inicio, fim) {
        this.jornadaDoDia.alterarJornada(inicio, fim);
        return this;
    }
    atualizarDataDoPedido(data) {
        this.dataDoPedido = data;
        return this;
    }
    validarJornada() {
        if (this.dataDoPedidoEhAnteriorAHoje()) {
            throw new excecoes_1.PedidoDeHorasExtrasParaPeriodoPassado();
        }
        if (this.pedidoEstaDentroDaJornada()) {
            throw new excecoes_1.PedidoIntercedeJornadaDoDia();
        }
        if (this.pedidoTemHorariosIguais()) {
            throw new excecoes_1.ErroPedidoHorariosIguais();
        }
        return this;
    }
    jornadaDoDiaAtravessaDia() {
        return this.jornadaDoDia.jornadaAtravessaDia();
    }
    inicioPedidoEhAposMeioDia() {
        const MEIO_DIA_EM_MINUTOS = 720;
        const horas = this.jornadaDeHorasExtras.inicio.getHours();
        const minutos = this.jornadaDeHorasExtras.inicio.getMinutes();
        const minutosTotais = horas * 60 + minutos;
        if (minutosTotais >= MEIO_DIA_EM_MINUTOS) {
            return true;
        }
        return false;
    }
    pedidoEstaDentroDaJornada() {
        const dataBase = new Date(this.dataDoPedido);
        let fimPedido, fimJornada, inicioPedido;
        const inicioJornada = Jornada.concatenarDataEmHorario(dataBase, this.jornadaDoDia.inicio);
        inicioPedido = Jornada.concatenarDataEmHorario(dataBase, this.jornadaDeHorasExtras.inicio);
        fimPedido = Jornada.concatenarDataEmHorario(dataBase, this.jornadaDeHorasExtras.fim);
        fimJornada = Jornada.concatenarDataEmHorario(dataBase, this.jornadaDoDia.fim);
        if (this.jornadaDoDia.jornadaAtravessaDia()) {
            fimJornada = Jornada.adicionarUmDiaNaData(fimJornada);
            if (!this.inicioPedidoEhAposMeioDia()) {
                inicioPedido = Jornada.adicionarUmDiaNaData(inicioPedido);
            }
        }
        if (this.jornadaDeHorasExtras.jornadaAtravessaDia()) {
            fimPedido = Jornada.adicionarUmDiaNaData(fimPedido);
        }
        const inicioPedidoEhAposInicioJornada = inicioPedido.getTime() > inicioJornada.getTime() &&
            inicioPedido.getTime() < fimJornada.getTime();
        const fimPedidoEhAntesDoFimJornada = fimPedido.getTime() < fimJornada.getTime() &&
            fimPedido.getTime() > inicioJornada.getTime();
        const inicioPedidoEhAntesEFimPedidoEhDepois = inicioPedido.getTime() < inicioJornada.getTime() &&
            fimPedido.getTime() > fimJornada.getTime();
        return (inicioPedidoEhAposInicioJornada ||
            fimPedidoEhAntesDoFimJornada ||
            inicioPedidoEhAntesEFimPedidoEhDepois);
    }
    dataDoPedidoEhAnteriorAHoje() {
        const dataDoPedido = new Date(this.dataDoPedido).setHours(0, 0, 0, 0);
        const hoje = new Date().setHours(0, 0, 0, 0);
        return dataDoPedido < hoje;
    }
    pedidoTemHorariosIguais() {
        return (this.jornadaDeHorasExtras.inicio.getTime() ===
            this.jornadaDeHorasExtras.fim.getTime());
    }
}
exports.ValidadorDePedidoDeHorasExtras = ValidadorDePedidoDeHorasExtras;
const tipoDeJornada = (dayJourneyLinha) => {
    const { isVacation: ehFerias, isHoliday: ehFeriado, isWorkDay: ehDiaDeTrabalho, journey: jornada, } = dayJourneyLinha;
    const { justify: ehDispensa, suspend: ehAfastamento, kind } = jornada;
    const ehSemJornada = 'id' in jornada === false;
    const ehFolga = kind < 0;
    return {
        ehFerias,
        ehFeriado,
        ehDiaDeTrabalho,
        ehDispensa,
        ehAfastamento,
        ehSemJornada,
        ehFolga,
    };
};
exports.tipoDeJornada = tipoDeJornada;
const estiloJornada = (tipoDeJornada) => {
    const { ehFerias, ehFeriado, ehDiaDeTrabalho, ehDispensa, ehAfastamento, ehSemJornada, ehFolga, } = tipoDeJornada;
    if (!ehDiaDeTrabalho ||
        ehDispensa ||
        ehAfastamento ||
        ehSemJornada ||
        ehFolga) {
        return {
            '--corDaJornada': '#FF6854', // jornadaSemTrabalho || dispensa || afastamento
        };
    }
    else if (ehFerias) {
        return {
            '--corDaJornada': '#00A2B5', // ferias
        };
    }
    else if (ehFeriado) {
        return {
            '--corDaJornada': '#FFD700', // feriado
        };
    }
    else {
        return {
            '--corDaJornada': '#0C9B73', // tem jornada
        };
    }
};
exports.estiloJornada = estiloJornada;
//# sourceMappingURL=pedido-de-horas-extras.servico.js.map